import {createSelector} from 'reselect';
import * as ScreenSizes from '../utils/ScreenSizes';

export const getScreenWidth = state => state.ui.screenDimensions.width;

export const getDeviceType = createSelector(
  [getScreenWidth],
  screenWidth => ScreenSizes.getDeviceType(screenWidth),
);

export const isMobile = createSelector(
  [getDeviceType],
  deviceType => deviceType === ScreenSizes.MOBILE,
);
